import { airportListDataSchema, salesSchema } from '@library/models'
import type {
  SalesInformationRequest,
  AirportListData,
  Sales
} from '@library/models'
import type ApiFactory from '@library/services/api-factory'
import { apiValidator } from '@library/services/decorators'
import type { ApiResponse } from '@library/services/types/api-response'

export default class BfAuthApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 取得航點清單
   * 前台 - https://hackmd.io/rI_zZbS6T-iGmjJOVe6wwA
   * 後台 - https://hackmd.io/OZxy5yAlRwWpw4cky6AT3Q
   */
  @apiValidator(airportListDataSchema.array())
  getAirport(): Promise<ApiResponse<AirportListData[]>> {
    return this.api.get('Common/GetAirport')
  }

  /**
   * API 取得營業人員資訊
   * 前台 - https://hackmd.io/fh9k61oJQiGgYzfNpygJcg
   * 後台 - https://hackmd.io/zmqPdoOtQweaNYUEizZA4w
   */
  @apiValidator(salesSchema.array())
  getSalesInformation(
    data: SalesInformationRequest
  ): Promise<ApiResponse<Sales[]>> {
    return this.api.post('Common/GetSalesInformation', data)
  }
}
